<div *ngIf="!cardView">
    <div class="card">
        <div class="p-grid">
            <div class="p-col">
                <h5>Cheatsheet</h5>
                <small></small>
            </div>
            <div class="p-col">
                <button type="button" pButton (click)="openEstimateDialog()" icon="pi pi-plus" label="Add"></button>
            </div>
        </div>
       
    </div>
    
    <div class="card">
        <p-table [value]="estimateItems" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>Hours</th>
                    <th>Remove</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{item.name}}</td>
                    <td>{{item.hours}}</td>
                    <td><button type="button" class="p-button-danger" pButton (click)="removeEstimateItem(item.criteria)" icon="pi pi-trash" label="Remove"></button></td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-car let-columns="columns">
                <p>No Estimate Items Set</p>
            </ng-template>
        </p-table>
    </div>
</div>

<div *ngIf="cardView">
    <h5><p-badge [value]="estimateItems.length"></p-badge> Cheatsheet</h5>
    <a routerLink="/franchise-management/cheatsheet">View Cheatsheet</a>
</div>




<p-dialog header="Estimate" [(visible)]="showDialog">
    <input type="text" [(ngModel)]="itemToCreate.name" pInputText placeholder="Name"
    (keyup)="validate('name')" (focusout)="focusOut('name')"
    [class.p-invalid-input]="!validation.name.valid && validation.name.touched" />
    <small class="field-error-message" *ngIf="!validation.name.valid && validation.name.touched">{{validation.name.message}}</small>
    <br>
    <br>
    <input type="number" step="1" [(ngModel)]="itemToCreate.crewSize" pInputText placeholder="Crew Size" 
    (keyup)="validate('crewSize')" (focusout)="focusOut('crewSize')"
    [class.p-invalid-input]="!validation.crewSize.valid && validation.crewSize.touched"/>
    <small class="field-error-message" *ngIf="!validation.crewSize.valid && validation.crewSize.touched">{{validation.crewSize.message}}</small>
    <br>
    <br>
    <input type="number" step="1" [(ngModel)]="itemToCreate.hours" pInputText placeholder="Hours" 
    (keyup)="validate('hours')" (focusout)="focusOut('hours')"
    [class.p-invalid-input]="!validation.hours.valid && validation.hours.touched"/>
    <small class="field-error-message" *ngIf="!validation.hours.valid && validation.hours.touched">{{validation.hours.message}}</small>
    <br>
    <br>
    <!-- <input type="number" [(ngModel)]="itemToCreate.hours" pInputText placeholder="Discount" /> -->
    <br>

    <ng-template pTemplate="footer">
        <button type="button" class="p-button-success" [disabled]="!validation.hours.valid || !validation.name.valid || !validation.crewSize.valid" pButton (click)="addEstimateItem()" icon="pi pi-plus" label="Create item"></button>
    </ng-template>

</p-dialog>